import ar from './ar.json' with { type: 'json' };
import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };
import es_ES from './es_ES.json' with { type: 'json' };
import es_MX from './es_MX.json' with { type: 'json' };
import fr from './fr.json' with { type: 'json' };
import id from './id.json' with { type: 'json' };
import it from './it.json' with { type: 'json' };
import ja from './ja.json' with { type: 'json' };
import ko from './ko.json' with { type: 'json' };
import pt from './pt.json' with { type: 'json' };
import ru from './ru.json' with { type: 'json' };
import th from './th.json' with { type: 'json' };
import tr from './tr.json' with { type: 'json' };
import zh_Hans from './zh_Hans.json' with { type: 'json' };
import zh_Hant from './zh_Hant.json' with { type: 'json' };
import hi from './hi.json' with { type: 'json' };

export default { ar, de, en, es_ES, es_MX, fr, id, it, ja, ko, pt, ru, th, tr, zh_Hans, zh_Hant, hi }